module.exports = "https://cdn.realtymogul.com/static/media/icon_protection.e9917a29.svg";